var _style, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#496E2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,256c0,97,54,181.5,133.6,224.9V31.1C54,74.5,0,159,0,256L0,256z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0c-44.4,0-86.1,11.3-122.4,31.1v449.7C169.9,500.7,211.6,512,256,512c141.4,0,256-114.6,256-256 S397.4,0,256,0z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.5,298.3c-32.4,23.4-77.6,16.1-101-16.3c-23.4-32.4-16.1-77.6,16.3-101c10.1-7.3,21.4-11.6,33-13.1 c-22.2-3.3-45.7,1.7-65.3,15.9c-39.9,28.8-48.8,84.5-20,124.3c28.8,39.9,84.5,48.8,124.3,20c19.6-14.2,31.8-34.9,35.6-57 C383.2,281.6,375.6,291,365.5,298.3L365.5,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.1,167l18.2,19.7l24.3-11.3l-13.1,23.4l18.2,19.7l-26.3-5.2l-13.1,23.4l-3.2-26.6l-26.3-5.2l24.3-11.3 L364.1,167z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/pk.e874b7d0bf81b0a9bbbf066d0177719c.svg";
export { ForwardRef as ReactComponent };